const state = {
    currentLeaderboard: undefined,
    transactions: undefined,
};

export default state;
